<template>
   <b-container class="p-0" :class="[{'mail-option' : registerOption}, {'pj': registerForm.additionalInformation.type === 'pj'}]" fluid id="login">
      <b-row class="h-100">
         <b-col align-self="center" :md="modal ? 12 : 6">

            <div class="text-center" v-if="false">
               <router-link to="/"><img class="brand" src="@/assets/img/logo-pedale.png" alt=""></router-link>
            </div>

            <section class="banner-mobile bg-cover d-block d-md-none position-relative mb-4" :style="{ background: `url(${bgLogin})` }">
               <div style="z-index: 1" class="position-relative">
                  <h1 class="h2 font-weight-bold text-white text-center">Faça seu cadastro na Pedale</h1>
                  <p style="font-weight: 500;" class="text-white text-center lead">Entre com seus dados para registrar sua conta.</p>
               </div>
               <div class="mask"></div>
               <b-container class="h-100 calendar-home-wrap">
                  <b-row no-gutters align-v="center" class="h-100">
                     <b-col md="8" lg="6" xl="5">
                        <!--busca-->

                     </b-col>
                  </b-row>
               </b-container>
            </section>

            <b-row align-h="center">
               <b-col :lg="modal ? 12 : 12" :xl="modal ? 12 : 10" class="">

                  <div class="text-center title mb-3 d-none d-md-block">
                     <h4 v-if="!modal">Registrar</h4>
                  </div>

                  <div v-if="0" :class="{'d-none': registerOption}" class="text-center social-option">
                     <el-button type="default" class="d-block w-100 font-weight-bold btn-icon btn-facebook" round>
                        <v-icon class="icon-facebook" name="brands/facebook-f"></v-icon>
                        ENTRAR COM O FACEBOOK
                     </el-button>

                     <div class="text-muted" style="font-size: .8rem">-- OU --</div>
                  </div>

                  <!--===== Register Login =====-->
                  <el-form
                     :class="{'d-none': !registerOption}"
                     :inline="true"
                     id="registerForm"
                     :model="registerForm"
                     :rules="rules"
                     ref="registerForm"
                     class="login-form"
                     size="medium"
                     :disabled="loading.btnForm"
                  >

                     <b-row class="bg-light p-3 rounded-lg mb-3 text-center border seletor">
                        <b-col lg="12" class="pb-0">
                           <el-form-item label="Tipo de Cadastro" prop="additionalInformation.type" class="mb-0 type-of-registration">
                              <el-radio-group
                                 @change="registerForm.additionalInformation.cpf = ''"
                                 v-model="registerForm.additionalInformation.type"
                                 size="medium"
                                 class="dark"
                              >
                                 <el-radio border label="pf">Pessoa Física</el-radio>
                                 <el-radio border label="pj">Pessoa Jurídica</el-radio>
                                 <el-radio border label="passport">Pessoa Estrangeira</el-radio>
                              </el-radio-group>
                           </el-form-item>
                        </b-col>
                     </b-row>

                     <!-- Nome e Razão Social da Empresa  -->
                     <b-row v-if="registerForm.additionalInformation.type === 'pj'">

                        <b-col lg="6" class="pr-3 pr-lg-0">
                           <el-form-item label="Nome da Empresa" prop="additionalInformation.businessName">
                              <el-input
                                 type="text"
                                 v-model="registerForm.additionalInformation.businessName"
                                 placeholder="Informe o Nome da Empresa"></el-input>
                           </el-form-item>
                        </b-col>

                        <b-col lg="6">
                           <el-form-item label="Razão Social" prop="additionalInformation.corporateName">
                              <el-input
                                 type="text"
                                 v-model="registerForm.additionalInformation.corporateName"
                                 placeholder="Informe a Razão Social"></el-input>
                           </el-form-item>
                        </b-col>

                     </b-row>

                     <!-- Nome e Sobrenome -->
                     <b-row>

                        <b-col lg="6" class="pr-3 pr-lg-0">
                           <el-form-item
                              :label="['pf', 'passport'].includes(registerForm.additionalInformation.type) ? 'Nome' : 'Nome do Responsável'"
                              prop="firstName">
                              <el-input
                                 type="text"
                                 v-model.trim="registerForm.firstName"
                                 placeholder="Digite seu Primeiro Nome"></el-input>
                           </el-form-item>
                        </b-col>

                        <b-col lg="6">
                           <el-form-item
                              :label="['pf', 'passport'].includes(registerForm.additionalInformation.type) ?
                      'Sobrenome' : 'Sobrenome do Responsável'"
                              prop="lastName">
                              <el-input
                                 type="text"
                                 v-model="registerForm.lastName"
                                 placeholder="Digite seu Sobrenome"></el-input>
                           </el-form-item>
                        </b-col>
                     </b-row>

                     <b-row>

                        <!-- CPF -->
                        <b-col v-if="registerForm.additionalInformation.type === 'pf'" lg="6" class="pr-3 pr-lg-0">
                           <el-form-item label="CPF" prop="additionalInformation.cpf" :class="{'is-error' : existingCpf}">
                              <el-input
                                 v-mask="'###.###.###-##'"
                                 @blur="existingCpf = false"
                                 type="text"
                                 v-model="registerForm.additionalInformation.cpf"
                                 placeholder="Digite seu CPF"></el-input>
                           </el-form-item>
                        </b-col>

                        <!-- CNPJ -->
                        <b-col v-if="registerForm.additionalInformation.type === 'pj'" lg="6" class="pr-3 pr-lg-0">
                           <el-form-item label="CNPJ" prop="additionalInformation.cpf">
                              <el-input
                                 v-mask="'##.###.###/####-##'"
                                 type="text"
                                 v-model="registerForm.additionalInformation.cpf"
                                 placeholder="Digite seu CNPJ"></el-input>
                           </el-form-item>
                        </b-col>

                        <!-- Passaporte -->
                        <b-col v-if="registerForm.additionalInformation.type === 'passport'" lg="6" class="pr-3 pr-lg-0">
                           <el-form-item  label="Passaporte" prop="additionalInformation.cpf">
                              <el-input
                                 v-mask="'XXXXXXXXX'"
                                 type="text"
                                 v-model="registerForm.additionalInformation.cpf"
                                 placeholder="AA123456"></el-input>
                           </el-form-item>
                        </b-col>

                        <!-- Campo email -->
                        <b-col lg="6">
                           <el-form-item label="E-mail" prop="email" :class="{'is-error' : existingEmail}">
                              <el-input
                                 @blur="existingEmail = false"
                                 type="mail"
                                 v-model.trim="registerForm.email"
                                 placeholder="Digite seu E-mail"></el-input>
                           </el-form-item>
                        </b-col>
                     </b-row>

                     <!-- Campo Telefone -->
                     <b-row class="mb-3 mb-lg-0">
                        <b-col
                           :class="[
            {'pr-3' : registerForm.additionalInformation.type === 'pj'},
            {'pr-3 pr-lg-0' : ['pf', 'passport'].includes(registerForm.additionalInformation.type) }
        ]"
                        >
                           <el-form-item label="Telefone" prop="additionalInformation.phone">
                              <el-input
                                 v-mask="registerForm.additionalInformation.type === 'passport' ? null : ['(##) ####-####', '(##) #####-####']"
                                 v-model="registerForm.additionalInformation.phone"
                                 :placeholder="registerForm.additionalInformation.type === 'passport' ? '' : '(99) 99999-9999'"
                                 :maxlength="registerForm.additionalInformation.type === 'passport' ? 15 : null"
                                 @input="onPhoneInput"
                              >
                                 <template #prepend v-if="registerForm.additionalInformation.type === 'passport'">
                                    <el-select
                                       v-model="registerForm.additionalInformation.internationalPhoneAreaCode"
                                       placeholder="Código"
                                       style="width: 80px;"
                                       filterable
                                    >
                                       <el-option v-for="country in countryCodes" :key="country.name" :label="`+${country.code}`" :value="country.code">
                                          +{{ country.code }}  {{country.name}}
                                       </el-option>
                                    </el-select>
                                 </template>
                              </el-input>
                           </el-form-item>
                        </b-col>

                        <!-- Campo aniversário -->
                        <b-col
                           cols="10"
                           lg="5"
                           class="pr-0">
                           <el-form-item label="Data de Nascimento" prop="additionalInformation.dateOfBirth" class="pb-0 mb-0">
                              <el-input
                                 v-mask="'##/##/####'"
                                 v-model="registerForm.additionalInformation.dateOfBirth"
                                 placeholder="dd/mm/aaaa"/>
                           </el-form-item>
                        </b-col>

                        <b-col
                           :tabindex="-1"
                           cols="2"
                           lg="1">
                           <el-tooltip
                              :tabindex="-1"
                              class="item tooltip-dateOfBirth-login"
                              effect="dark"
                              content="Para se cadastrar, você deve ter 18 anos ou mais."
                              placement="top">
                              <i class="el-icon-info text-info"></i>
                           </el-tooltip>
                        </b-col>
                     </b-row>

                     <!-- Campo senha -->
                     <b-row>
                        <b-col lg="6" class="pr-3 pr-lg-0">
                           <el-form-item label="Senha" prop="password">
                              <el-input
                                 type="password"
                                 :maxlength="12"
                                 v-model.trim="registerForm.password"
                                 placeholder="Cadastre uma Senha"/>
                           </el-form-item>
                        </b-col>

                        <!-- Campo confirmar senha -->
                        <b-col lg="6">
                           <el-form-item label="Confirme a Senha" prop="confirmPassword">
                              <el-input
                                 type="password"
                                 v-model.trim="registerForm.confirmPassword"
                                 placeholder="Confirmar Senha"/>
                           </el-form-item>
                        </b-col>
                     </b-row>

                     <!-- Termos -->
                     <el-form-item prop="terms" class="pb-0 mb-0">

                        <el-checkbox
                           class="mb-0"
                           v-model="registerForm.terms">
                           <p class="m-0">Declaro que li e aceito os <a href="https://pedale.net.br/politicas-pedale/"
                                                            target="_blank"> termos, condições e acordo de locação</a>
                              da Pedale.</p>
                        </el-checkbox>
                     </el-form-item>

                     <!--Submit-->
                     <el-form-item class="text-center register-actions">
                        <el-button
                           type="primary"
                           class="mt-3 d-block w-100 font-weight-bold"
                           round
                           @click="submitRegisterForm('registerForm')"
                           :loading="loading.btnForm">
                           Registrar
                        </el-button>
                        <el-button
                           v-if="0"
                           @click="() => this.$router.push({name: 'login'})"
                           type="text"
                           class="mt-1"
                        >
                           Voltar
                        </el-button>
                     </el-form-item>
                  </el-form>
                  <!--===== End Form Login =====-->

                  <div v-if="!registerOption">
                     <el-button @click="registerMailTrigger()" type="primary"
                                class="d-block w-100 font-weight-bold btn-icon btn-register"
                                round>
                        <v-icon class="icon-facebook" name="envelope"></v-icon>
                        CADASTRAR COM E-MAIL
                     </el-button>

                     <div v-if="!modal" class="text-center mt-1">
                        <span class="text-muted">Já possui cadastro?</span>
                        <router-link to="/login"> Login</router-link>
                     </div>
                  </div>
                  <div v-if="!modal" class="text-center mt-1 mb-1">
                     <span class="text-muted">Já possui cadastro?</span>
                     <router-link to="/login"> Login</router-link>
                  </div>


               </b-col>
            </b-row>
         </b-col>
         <b-col class="position-relative order-first order-md-2 bg-fade-image-wrap register-cover" style="overflow: hidden;">
            <transition name="fade"> <!--animation-->
               <div v-if="!show"
                    style="background-color: green"
                    :style="{backgroundImage : `url(${ bgLogin })`}"
                    class="bg-fade-image bg-cover bg-center">
               </div>
            </transition>
            <transition name="fade"> <!--animation-->

               <div v-if="show"

                    style="background-color: green"
                    :style="{backgroundImage : `url(${ bgRegisterPj })`}"
                    class="bg-fade-image bg-cover bg-center">
               </div>
            </transition>


            <router-link to="/" class="back-to-site">← Voltar ao site</router-link>
         </b-col>
      </b-row>
   </b-container>

</template>

<script>
import bgLogin from '@/assets/img/cadastro-pedale.jpg';
import bgRegisterPj from '@/assets/img/register-pj.jpg';
import countryCodes from '@/data/countryCodes';
import { checkPhone, metaTags, onlyNumber, validarCNPJ, validarPassaporte } from "@/helpers";
import isMail from "@/helpers/checkEmail";
import isCpf from "@/helpers/cpf";
import AuthService from '@/services/auth.service';
import { useGtm } from "vue-gtm";
import { mask } from 'vue-the-mask';

export default {
   name: 'Register',
   metaInfo: metaTags(`Registrar`),
   props: {
      modal: {
         type: Boolean,
         default: false
      },
      namespace: {
         type: String,
         default: ''
      }
   },
   directives: {mask},
   data() {
      return {
        countryCodes: countryCodes,
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         bgLogin,
         bgRegisterPj,
         registerOption: true,
         loading: {
            state: false,
            city: true,
            btnForm: false,
         },
         registerForm: {
            firstName: '',
            lastName: '',
            email: '',
            additionalInformation: {
               internationalPhoneAreaCode: '55',
               type: 'pf',
               cpf: '',
               businessName: '',
               corporateName: '',
               phone: '',
               dateOfBirth: ''
            },
            password: '',
            confirmPass: '',
            confirmPassword: '',
            resources: {}
         },
         rules: {
            firstName: [
               {required: true, validator: this.checkFirstName, trigger: 'blur'}
            ],
            lastName: [
               {required: true, message: 'Digite seu Sobrenome', trigger: 'blur'}
            ],
            email: [
               {required: true, message: 'Preencha seu e-mail', trigger: 'blur'},
               {type: 'email', validator: this.checkEmail, trigger: 'blur'},
            ],
            additionalInformation: {
               type: [
                  {required: true, message: 'Selecione o tipo de cadastro', trigger: 'blur'}
               ],
               cpf: [
                  {validator: this.checkCpf, trigger: 'blur'},
               ],
               businessName: [
                  {required: true, message: 'Digite o nome da Empresa', trigger: 'blur'}
               ],
               corporateName: [
                  {required: true, message: 'Digite a Razão Social', trigger: 'blur'}
               ],
               phone: [
                  {required: true, message: 'Por favor, digite seu telefone', trigger: 'blur'},
                  {validator: this.checkPhoneHandler, trigger: 'blur'},
               ],
               dateOfBirth: [
                  {required: true, validator: this.checkDateBirth, trigger: 'blur'}
               ],
            },
            password: [
               {required: true, validator: this.checkPass, trigger: 'blur'}
            ],
            confirmPassword: [
               {required: true, validator: this.checkConfirmPassword, trigger: 'blur'}
            ],
            terms: [
               {required: true, message: 'Você precisa aceitar os termos.', trigger: 'blur'},
               { validator: this.checkTerms, trigger: 'blur'}
            ],
         },
         existingEmail: false,
         existingCpf: false,
         show: false,
         pushToken: null
      };
   },
   created() {
      if (this.loggedIn && !this.namespace) {
         this.$router.push('/painel/inicio')
      }
   },
   mounted() {
      this.getPushToken()
      useGtm.trackView("Registro", "/registrar");
   },
   methods: {

      // Obtém o token push do localStorage
      getPushToken() {
         this.pushToken = JSON.parse(localStorage.getItem('pushToken'))
      },

      checkPhoneHandler(rule, value, callback) {
         if (this.registerForm.additionalInformation.type !== 'passport') {
            checkPhone(rule, value, callback)
         } else {
            return callback()
         }
      },

      submitRegisterForm(form) {
         this.$refs[form].validate((valid) => {
            if (valid) {
               this.loading.btnForm = true;

               let cpf = this.registerForm.additionalInformation.cpf
               let dateOfBirth = this.registerForm.additionalInformation.dateOfBirth

               this.registerForm.additionalInformation.cpf = this.registerForm.additionalInformation.type !== "passport" ? onlyNumber(cpf) : cpf;
               this.registerForm.additionalInformation.dateOfBirth = this.formatDateBirth(dateOfBirth)
               this.registerForm.resources.pushToken = this.pushToken

               this.axios.post(`${this.baseUrl + this.apiV1}/auth/register`, this.registerForm)
                  .then((user) => {

                  this.$store.dispatch('auth/token', user.data)
                  localStorage.setItem('user', JSON.stringify(user.data))

                  if (!this.namespace) {
                     this.$message({
                        message: 'Cadastrado realizado com sucesso!',
                        type: 'success'
                     });

                     this.$router.push('/painel/inicio');
                  }

                  this.resetForm('registerForm');
                  this.loading.btnForm = false;

                  if (this.namespace === 'bike') {
                     //this.$router.push('/checkout')
                     this.$emit('registerDone', true)
                     this.$message({
                        message: 'Cadastrado realizado! Conclua sua reserva.',
                        type: 'success'
                     });

                     return false
                  }

                  if (this.namespace === 'bike/chat') {
                     return false
                  }
                  const gtm = useGtm();
                  gtm.enable(true)
                  gtm.trackEvent({
                     event: 'cadastro-finalizado', // Event type [default = 'interaction'] (Optional)
                     category: this.registerForm.additionalInformation.type,
                     action: "click",
                     label: "Tela de Cadastro",
                     value: 0,
                  });


               })
                  .catch(err => {

                  if (err.response.data.error === 'existingEmail') {
                     this.existingEmail = true;
                  }
                  //this.$message.error(err.response.data.message);
                  this.loading.btnForm = false;
               });

               // eslint-disable-next-line no-undef
               // gtag_report_conversion('registro')

            } else {
               this.loading.btnForm = false;
               this.$message.error('Preencha os campos corretamente!');
               return false;
            }
         });

      },

      registerMailTrigger() {
         this.registerOption = !this.registerOption;
      },

      checkCpf(rule, value, callback) {
         const docType = {
            pf: 'CPF',
            pj: 'CNPJ',
            passport: 'Passaporte'
         }[this.registerForm.additionalInformation.type]

         if (!value) {
            return callback(new Error(`Por favor, informe seu ${docType}`));
         }

         const onlyNumbersFromDoc = onlyNumber(value);

         let cpf = onlyNumbersFromDoc;

         if (this.registerForm.additionalInformation.type === 'pf' && !isCpf(onlyNumbersFromDoc)) return callback(new Error('CPF Inválido'));

         if (this.registerForm.additionalInformation.type === 'pj' && !validarCNPJ(onlyNumbersFromDoc)) return callback(new Error('CNPJ Inválido'));

         if (this.registerForm.additionalInformation.type === 'passport') {
            if(!validarPassaporte(value)){
                return callback(new Error('Passaporte Inválido'));
            }
            cpf = value;
        }

         AuthService.CheckInfo({cpf})
            .then(() => callback())
            .catch(() => callback(new Error(`${docType} já cadastrado!`)))
      },

      checkEmail(rule, value, callback) {

         if (!value) {
            return callback(new Error('Por favor, digite o seu e-mail'));
         }

         const email = value;

         if (!isMail(email)) {
            return callback(new Error('E-mail Inválido'));
         }

         AuthService.CheckInfo({email})
            .then(() => callback())
            .catch(() => callback(new Error('E-mail já cadastrado')))
      },

      //Formata data de aninversário
      checkDateBirth(rule, value, callback) {

         if (!value) {
            return callback(new Error('Por favor, digite a data'));
         }

         if (value.length !== 10) {
            callback(new Error('Digite a data corretamente'));
         }

         const currentYear = new Date().getFullYear();

         const dateBirth = value.split('/');
         const day = dateBirth[0];
         const month = dateBirth[1];
         const year = dateBirth[2];

         if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1000) {
            callback(new Error('Data inválida'));
         }

         if (currentYear - year < 18) {
            callback(new Error('Atenção: Somente maiores de 18 anos podem se cadastrar!'));
         }

         if (year < 1930) {
            callback(new Error('Desculpe, não podemos atender maiores de 90 anos'));
         }

         callback();
      },

      formatDateBirth(date) {
         let dateOfBirth = date.split('/');
         const day = dateOfBirth[0];
         const month = dateOfBirth[1];
         const year = dateOfBirth[2];

         dateOfBirth = `${year}/${month}/${day}`

         return this.$moment(dateOfBirth).locale('en').format("YYYY/MM/DD")
      },

      checkPass(rule, value, callback) {
         if (!value) {
            return callback(new Error('Por favor, digite sua senha'));
         }
         if (value.length < 6) {
            callback(new Error('Mínimo de 6 caracteres'));
         }
         if (value.length > 12) {
            callback(new Error('Máximo de 12 caracteres'));
         }

         callback();
      },

      checkConfirmPassword(rule, value, callback) {
         if (!value) {
            return callback(new Error('Por favor, confirme sua senha'));
         }
         if (value !== this.registerForm.password) {
            callback(new Error('As senhas não conferem!'));
         }

         callback();
      },

      checkFirstName(rule, value, callback) {

         const validName = value.split(' ').length === 1;

         if (!value) {
            return callback(new Error('Por favor, digite seu nome'));
         }

         if (!validName) {
            return callback(new Error("Somente o primeiro nome"))
         }

         callback();
      },

      resetForm(formName) {
         this.$refs[formName].resetFields();
      },

      checkTerms(rule, value, callback) {
         if (!value) {
            return callback(new Error('Você precisa aceitar os termos.'));
         }
         callback();
      },

      onPhoneInput(event) {
         // Permitir apenas números e limitar a 15 dígitos
         if (this.registerForm.additionalInformation.type === 'passport') {
            this.registerForm.additionalInformation.phone = event.replace(/\D/g, '').slice(0, 15);
         }
      }
   },
   computed: {
      loggedIn() {
         return this.$store.state.auth.status.loggedIn;
      }
   },
   watch: {

      'registerForm.dateOfBirth': function (n) {
         const dateValue = n.split('/');
         const dateFormated = [];

         if (n.length === 10) {
            let day = dateValue[0],
               month = dateValue[1],
               year = dateValue[2];

            if (day > 31) day = 31;
            if (month > 12) month = 12;

            dateFormated.push(day, month, year);

            this.registerForm.additionalInformation.dateOfBirth = dateFormated.join('/');
         }


      },
      'registerForm.additionalInformation.type': function (n) {
        this.show = n === 'pj' || false
         this.registerForm.additionalInformation.phone = ''
      },
   }

}
</script>

<style lang="scss">

@media (max-width: 767.98px) {
   .register {
      .banner-mobile {
         background: #1f443d;
         padding: 2rem 1.5rem;

         p {
            margin-bottom: 0;
         }

         .mask {
            background-color: rgba(31, 68, 61, 0.76);
         }
      }
   }
   #registerForm {
      padding: 0 20px;

      label {
         font-weight: bold;
      }

      .seletor {
         margin: 0;
      }
   }
   .register-cover {
      display: none;
   }
}


.type-of-registration {
   .el-form-item__label {
      margin-bottom: 15px;
   }

   label {
      font-weight: bold;
   }
}

</style>
